export default "__VITE_ASSET__D71i15sD__"